import errorHandlers from '@/services/error-handlers';


async function getTableOrder({ commit, dispatch, rootState }, options = {}) {
  try {
    const { isTableTopDevice } = rootState.session.route;

    const orderId = Number(rootState.session.route.orderId);

    if (!orderId || orderId !== rootState.orders.order.orderId) {
      if (!options.silent) {
        commit('orders/SET_ORDER_LOADING_STATUS', true, { root: true });
      }

      if (isTableTopDevice) {
        // Get all tickets associated with table number
        await dispatch('getTableTickets');

        if (rootState.orders.orders.length === 1) {
          // Get table order for ticket if there is only one.
          await dispatch('getTableOrders');

          const order = rootState.orders.orders[0];

          if (order) {
            // Set the single ticket order data.
            dispatch('setTableOrder', order);
          }
        }
      }
      else {
        await dispatch('getTableOrders');

        const order = rootState.orders.orders[0];

        if (order) {
          dispatch('setTableOrder', order);
        }
      }

      await dispatch('orders/loadStagedOrderItems', {}, { root: true });
    }
  }
  catch (error) {
    errorHandlers.silent(error);

    dispatch('session/unsetOrder', {}, { root: true });

    if (options.throw) {
      throw error;
    }
  }
  finally {
    commit('orders/SET_ORDER_LOADING_STATUS', false, { root: true });
  }
}

export { getTableOrder };
